/**
 * @method prioritizeArrayElement : "If we want to make some item of array to show always on top so this util we can use"
 * @param {Array} arr
 * @param {Array} priorityArray
 * @param {String} id
 * @return {Array}
 */
export const prioritizeArrayElement = (
  arr = [],
  priorityArray = [],
  id = '',
) => {
  const mainArr = [...arr];
  const referenceArray = [...priorityArray];
  const priority = Object?.fromEntries(referenceArray.map((k, i) => [k, i]));
  mainArr?.sort(
    (a, b) =>
      Object.prototype.hasOwnProperty.call(priority, b[id]) -
        Object.prototype.hasOwnProperty.call(priority, a[id]) ||
      priority[a[id]] - priority[b[id]],
  );
  return mainArr;
};

/**
 * @method formatMessageTime : "If we want show the date and time base on received date eg, [2023-06-27 16:10:10.0] required date format to use this util"
 * @param {String} timestamp
 * @return {String}
 */

export const formatMessageTime = (timestamp = '') => {
  const messageTime = new Date(timestamp);
  const now = new Date();
  //Calculate the time difference in milliseconds
  const timeDiff = now.getTime() - messageTime.getTime();
  //Convert milliseconds to minutes
  const minutesDiff = Math.floor(timeDiff / (1000 * 60));
  //If the message was sent less than 24 hours ago, show the time in "hh:mm AM/PM" format
  if (minutesDiff < 1440) {
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    return messageTime.toLocaleTimeString(undefined, options);
  }
  //Otherwise, format the date as "DD-MM-YYYY"
  const day = messageTime.getDate();
  const month = messageTime.getMonth() + 1;
  const year = messageTime.getFullYear();
  return month + '/' + day + '/' + year;
};

/**
 * @method formatMessageTime : "If we want show the date and time base on received date eg, [2023-06-27 16:10:10.0] required date format to use this util"
 * @param {String} inputDate
 * @return {String}
 */

export const formatMessageDateAndTime = (inputDate = '') => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dateObj = new Date(inputDate);

  const day = days[dateObj.getDay()];
  const date = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const period = hours >= 12 ? 'PM' : 'AM';

  const formattedMinutes = minutes.toString().padStart(2, '0');

  const formattedDate = `${day} ${month}/${date}/${year} ${formattedHours}:${formattedMinutes}${period}`;
  return formattedDate;
};
